import React from "react";
import MyProject from "./MyProject";

const project = [
  {
    id: 1,
    name: "Text Utils",
    author: ["Nahal"],
    description:
      "Text editor",
    technologies: [
      "HTML",
      "CSS",
      "BOOTSTRAP",
      "JS",
      "REACT"
    ],
    url: "https://your-text-utilities.vercel.app/",
  },
  { id: 2,
    name: "Github Users Searcher",
    author: ["Nahal"],
    description:
      "A website that generates text for you",
    technologies: [
      "HTML",
      "CSS",
      "JS"
    ],
    url: "https://nahal-mughal.github.io/search-github-users-api.github.io/",
  },
  
  { id: 3,
    name: "Random Text Generator",
    author: ["Nahal"],
    description:
      "A website that generates text for you",
    technologies: [
      "HTML",
      "CSS",
      "JS"
    ],
    url: "https://nahal-mughal.github.io/random-text.github.io/",
  },
  { id: 4,
    name: "Music Player",
    author: ["Nahal"],
    description:
      "A simple music player",
    technologies: [
      "HTML",
      "CSS",
      "JS"
    ],
    url: "https://nahal-mughal.github.io/music-player.github.io/",
  },
  { id: 5,
    name: "Text Reader AI",
    author: ["Nahal"],
    description:
      "A website that reads your entered text",
    technologies: [
      "HTML",
      "CSS",
      "JS"
    ],
    url: "https://nahal-mughal.github.io/text-reader.github.io/",
  },

  { id: 6,
    name: "Movie Searcher",
    author: ["Nahal"],
    description:
      "A website that searches the latest moves with descripton and rating",
    technologies: [
      "HTML",
      "CSS",
      "JS"
    ],
    url: "https://nahal-mughal.github.io/movie-search-api.github.io/",
  },
  { id: 7,
    name: "Weather Searcher",
    author: ["Nahal"],
    description:
      "A website that gives the latest weather of a city",
    technologies: [
      "HTML",
      "CSS",
      "JS"
    ],
    url: "https://nahal-mughal.github.io/weather-api.github.io/",
  },
  { id: 8,
    name: "Quiz",
    author: ["Nahal"],
    description:
      "A website that gives a demo of quiz",
    technologies: [
      "HTML",
      "CSS",
      "JS"
    ],
    url: "https://nahal-mughal.github.io/c-language-quiz.github.io/",
  }
];

function Cards() {
  return (
    <div className="container-fluid cards__container align-items-center py-5">
      <div className="container">
        <div className="row row align-items-center justify-content-center py-3"></div>
        {project.map((card) => (
          <MyProject
            name={card.name}
            imageP={card.imgP}
            Create={card.create}
            imageS={card.imgS}
            Author={card.author}
            Description={card.description}
            Technologies={card.technologies}
            Url={card.url}
          />
        ))}
      </div>
    </div>
  );
}

export default Cards;
